<template>
	<div class="review-card-container">
		<div class="review-section">
			<div class="review-section-title">
				<icon icon="user" class="section-icon" group="regular" />
				<span>{{ $t('install.wizard.sidebarTitle.admin-details') }}</span>
			</div>
			<div class="review-row">
				<span class="review-key">{{ $t('install.adminDetails.f.username') }}</span>
				<span class="review-val">{{ localData?.adminDetails?.username || '—' }}</span>
			</div>
			<div class="review-row">
				<span class="review-key">{{ $t('install.adminDetails.f.email') }}</span>
				<span class="review-val">{{ localData?.adminDetails?.email || '—' }}</span>
			</div>
		</div>

		<div class="review-section">
			<div class="review-section-title">
				<icon icon="sitemap" class="section-icon" group="regular" />
				<span>{{ $t('install.wizard.sidebarTitle.codings') }}</span>
			</div>
			<div class="review-row">
				<span class="review-key">{{ $t('install.codings.f.install') }}</span>
				<span class="review-val">{{ localData?.codings?.install ? 'فعال' : 'غیرفعال' }}</span>
			</div>
			<div class="review-row">
				<span class="review-key">{{ $t('install.codings.f.install-floating-centers') }}</span>
				<span class="review-val">{{ localData?.useDefaultFloatingCenterGroup ? 'فعال' : 'غیرفعال' }}</span>
			</div>
		</div>

		<div class="review-section">
			<div class="review-section-title">
				<icon icon="calendar-alt" class="section-icon" group="regular" />
				<span>{{ $t('install.wizard.sidebarTitle.company-fiscal') }}</span>
			</div>
			<div class="review-row">
				<span class="review-key">{{ $t('install.company.f.name') }}</span>
				<span class="review-val">{{ localData?.company?.name || '—' }}</span>
			</div>
			<div class="review-row">
				<span class="review-key">{{ $t('install.fiscalPeriod.f.name') }}</span>
				<span class="review-val">{{ localData?.fiscalPeriod?.name || '—' }}</span>
			</div>
			<div class="review-row" v-if="localData?.fiscalPeriod?.startDate">
				<span class="review-key">{{ $t('install.fiscalPeriod.f.startDate') }}</span>
				<span class="review-val">{{ formatPersianDate(localData.fiscalPeriod.startDate) }}</span>
			</div>
			<div class="review-row" v-if="localData?.fiscalPeriod?.endDate">
				<span class="review-key">{{ $t('install.fiscalPeriod.f.endDate') }}</span>
				<span class="review-val">{{ formatPersianDate(localData.fiscalPeriod.endDate) }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import _ from 'lodash'

	export default {
		props: ['modelValue'],
		data() {
			return {
				localData: null,
			}
		},
		watch: {
			modelValue: {
				deep: true,
				immediate: true,
				handler(val) {
					this.localData = _.cloneDeep(val)
				}
			}
		},
		methods: {
			formatPersianDate(dateVal) {
				if (!dateVal) return '—'
				try {
					return new Date(dateVal).toLocaleDateString('fa-IR')
				} catch (e) {
					return String(dateVal)
				}
			}
		}
	}
</script>

<style></style>
